<!-- TEMPLATE -->
<template>
  <div :class="deanHeaderItem">
    <div
      :id="'menu-item-' + id"
      class="dean-header-item-content"
      @click="deanHeaderItemClick"
    >
      <img
        v-if="img"
        class="dean-header-item-content-icon"
        :src="img"
        :height="deanHeaderItemIconSize"
        :width="deanHeaderItemIconSize"
      />
      <dean-icon
        v-else
        class="dean-header-item-content-icon"
        :glyph="icon"
        :height="deanHeaderItemIconSize"
        :width="deanHeaderItemIconSize"
      >
      </dean-icon>
      <p><slot></slot></p>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// SVG
import empty from '../svg/icons/empty.svg';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})
export default class deanHeaderItem extends Vue {
  // PROPS
  @Prop() data!: object;
  @Prop() state!: string;
  @Prop() id!: string;
  @Prop({ default: false }) standard!: boolean;
  @Prop({ default: false }) active!: boolean;
  @Prop({ default: false }) mobile!: boolean;
  @Prop({ default: false }) grid!: boolean;
  @Prop({ default: false }) list!: boolean;
  @Prop({ default: '30' }) height!: string;
  @Prop({ default: '30' }) width!: string;
  @Prop({
    default: function() {
      return empty;
    }
  })
  icon!: object;
  @Prop({ default: ''}) img!: string;

  empty: object = empty;

  // COMPUTED
  get deanHeaderItem() {
    let value = 'dean-header-item';
    if (this.list) {
      value = `dean-header-item-list`;
    } else {
      if (this.mobile) {
        value += ` dean-header-item-grid small-4 columns`;
      } else {
        if (this.grid) {
          value += ` dean-header-item-grid`;
        } else {
          value += ` dean-header-item-menu`;
        }
      }
    }
    if (this.active) value += ` dean-header-item-active`;
    if (this.state) {
      value += ` dean-header-item-${this.state}`;
    }
    return value;
  }

  get deanHeaderItemIconSize() {
    let size = '30';
    if (this.list) {
      size = '15';
    } else {
      size = '30';
    }
    return size;
  }

  // METHODS
  deanHeaderItemClick() {
    this.$emit('dean-header-item-click');
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER ITEM
.dean-header-item {
  display: inline-block;
  height: 100%;
  cursor: pointer;
  border-bottom: 4px solid white;
  @include transition(all ease 0.8s);
  margin: 0;
  user-select: none;

  .dean-header-item-content {
    display: block;
    min-width: 80px;
    padding: 0;
    margin: auto;
    @include vertical-align(55%);

    .dean-header-item-content-icon {
      display: block;
      height: 30px;
      margin: auto;
      text-align: center;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
      @include transition(all ease 0.8s);
    }

    p {
      display: block;
      padding: 5px;
      padding-top: 10px;
      margin: 0;
      min-height: 29px;
      text-align: center;
      min-width: 100%;
      max-width: 80px;
      white-space: nowrap; /* Don't forget this one */
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      color: var(--color-dark, $color-dark);
      font-weight: 500;
      font-size: 12px;
      @include hyphens(auto);
    }

    &:hover {
      color: var(--color-link, $color-link);
      .dean-header-item-content-icon {
        fill: var(--color-link, $color-link);
      }
      p {
        color: var(--color-link, $color-link);
      }
    }
  }
  &:hover {
    // border-bottom: 4px solid var(--color-link, $color-link);; //var(--color-link, $color-link);
    .dean-header-item-content {
      .dean-header-item-content-icon {
        fill: var(--color-link, $color-link);
      }
      p {
        fill: var(--color-link, $color-link);
      }
    }
  }
}

.dean-header-item-grid {
  float: left;
  padding: 10px 0px 10px 0px;
  border: none;
  &:hover {
    border: none;
  }
  .dean-header-item-content {
    height: 80px;
    width: 80px;
    @include vertical-align(0);
  }
}

.dean-header-item-list {
  height: 100%;
  padding: 0;

  .dean-header-item-content {
    display: block;
    padding: 15px;
    height: auto;
    width: auto;
    text-decoration: none;
    text-align: left;
    cursor: pointer;
    @include border-radius(10px);
    @include transition(all ease 0.8s);
    &:hover,
    &:focus {
      color: var(--color-link, $color-link);
      .dean-header-item-content-icon {
        fill: var(--color-link, $color-link);
      }
    }
    p {
      display: inline-block;
      text-align: left;
      margin: 0;
      padding: 0 0 0 10px;
    }

    .dean-header-item-content-icon {
      display: inline-block;
      position: relative;
      fill: var(--color-dark-shade-4, $color-dark-shade-4);
      @include transition(all ease 0.8s);
    }
  }
}

// ACTIVE
.dean-header-item-menu.dean-header-item-active {
  border-bottom: 4px solid var(--color-secondary, $color-secondary);
  .dean-header-item-content {
    .dean-header-item-content-icon {
      fill: var(--color-primary, $color-primary);
    }
    p {
      color: var(--color-primary, $color-primary);
    }
  }
}

.dean-header-item-list.dean-header-item-active,
.dean-header-item-grid.dean-header-item-active {
  border: none;
  .dean-header-item-content {
    color: var(--color-primary, $color-primary);
    .dean-header-item-content-icon {
      fill: var(--color-primary, $color-primary);
    }
  }
}
</style>
